import { render, staticRenderFns } from "./AreaPreview.vue?vue&type=template&id=6f8347e7&scoped=true"
import script from "./AreaPreview.vue?vue&type=script&lang=js"
export * from "./AreaPreview.vue?vue&type=script&lang=js"
import style0 from "./AreaPreview.vue?vue&type=style&index=0&id=6f8347e7&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f8347e7",
  null
  
)

export default component.exports